import { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { TAB_WIDTH } from '../../../config'

export const useResponsive = (): boolean => {
  const [isResponsive, setIsResponsive] = useState<boolean>(Dimensions.get('window').width <= TAB_WIDTH)

  useEffect(() => {
    const updateResponsive = () => {
      setIsResponsive(Dimensions.get('window').width <= TAB_WIDTH);
    };

    updateResponsive(); // Mise à jour immédiate au montage

    const subscription = Dimensions.addEventListener('change', updateResponsive);

    return () => {
      subscription?.remove?.();
    };
  }, [])

  return isResponsive
}
